/* eslint-disable react-hooks/exhaustive-deps */
import { ServerConfig } from "@xapp/stentor-chat-widget";
import { createContext, useEffect, useState } from "react";
import { throwBadKind } from "../utils/throwBadKind";
import { useChatDispatch } from "../utils/useChatDispatch";
import { ChatServer, ChatServerOptions } from "./ChatServer";
import { LogChat } from "./LogChat";
import { StentorDirectChat } from "./StentorDirectChat";
import { StentorLocalChat } from "./StentorLocalChat";
import { StentorRouterChat } from "./StentorRouterChat";
import { StentorServerChat } from "./StentorServerChat";

function createChatServerCore(config: ServerConfig, options?: ChatServerOptions): ChatServer {
    switch (config.type) {
        case "direct":
            return new StentorDirectChat(
                {
                    url: config.serverUrl,
                    key: config.accountKey,
                    timeout: config.timeout,
                },
                options
            );
        case "websocket":
            return new StentorServerChat(
                {
                    url: config.serverUrl,
                },
                options
            );
        case "websocketraw":
            return new StentorRouterChat(
                {
                    url: config.serverUrl,
                },
                options
            );
        case "local":
            return new StentorLocalChat();
        default:
            throw throwBadKind(config.type);
    }
}

export function createChatServer(config: ServerConfig, options?: ChatServerOptions): ChatServer {
    return new LogChat(createChatServerCore(config, options));
}

export const ChatServerContext = createContext<ChatServer>(null);

export function useChatServer(
    config: ServerConfig | null,
    options?: ChatServerOptions | null
): ChatServer {
    const [server, setServer] = useState<ChatServer>();

    const dispatch = useChatDispatch();

    const deps = [options, config, dispatch];

    // Log what caused the "effect"
    // useWhatChanged(deps, "options, config, dispatch");

    useEffect(() => {
        // Don't create server if config is null (waiting for async config load)
        if (!config || !options) {
            setServer(undefined);
            return undefined;
        }

        const newServer = createChatServer(config, options);

        newServer.init(dispatch);

        setServer(newServer);
        return () => {
            newServer.dispose();
        };
    }, deps);

    return server;
}
